import Field from "./Field";

class BooleanField extends Field {
    constructor(name) {
        super(name);
        this._type = "boolean";
    }
}

export default BooleanField;



/** WEBPACK FOOTER **
 ** ./~/ng-annotate-loader/loader.js!./~/admin-config/lib/Field/BooleanField.js
 **/